export const splitApplyJoin = (
    transportType: string,
    t: (id: string) => any,
    delimiter: string): string => {
  return transportType.split(delimiter).map(tt => t(tt)).join(delimiter)
}
